import currencySelectionTrigger from './currencySelectionTrigger';
import languageSelectionTrigger from './languageSelectionTrigger';
import localeSelectionTrigger from './localeSelectionTrigger';

export const EntryTypes = {
    currencySelectionTrigger,
    languageSelectionTrigger,
    localeSelectionTrigger,
};
